import { translate } from "@/i18n";
import { agentActivityUiMessages } from "@/i18n/messages/agent-activity-ui";
import type { WorkToastActivityEntry, WorkToastItem } from "@/stores/work-toast-store";
import { renderActivityLabel } from "./activity-label";

export const WORK_TOAST_TEXT_PREVIEW_CHARS = 80;
const TEXT_COUNTER_ID = /^text:(.+):(\d+)$/;

/** "Slack, reading thread": the app, then the step in plain words (compact
 *  surface standard §8 — second lines carry no middle dots), in the app
 *  language. Call at render time. */
export function activityEntryLabel(
  entry: Pick<WorkToastActivityEntry, "app" | "action" | "actionLabel" | "text">,
): string {
  if (entry.text) return entry.text;
  const action = entry.action && renderActivityLabel(entry.actionLabel, entry.action);
  if (entry.app && action) return translate(agentActivityUiMessages, "ui.app_step", { app: entry.app, action });
  return entry.app ?? action ?? "";
}

export function textActivityFromContent(content: string): string | null {
  const collapsed = content.split(/\s+/).filter(Boolean).join(" ");
  if (!collapsed) return null;
  if (collapsed.length <= WORK_TOAST_TEXT_PREVIEW_CHARS) return collapsed;
  const head = collapsed.slice(0, WORK_TOAST_TEXT_PREVIEW_CHARS);
  const boundary = head.lastIndexOf(" ");
  return `${boundary > 0 ? head.slice(0, boundary) : head}…`;
}

export function activityTextId(stepId: string | null, item: Pick<WorkToastItem, "key" | "activity">): string {
  if (stepId) return `text:${stepId}`;
  const ring = item.activity ?? [];
  const last = ring[ring.length - 1];
  if (last?.kind === "text" && TEXT_COUNTER_ID.test(last.id)) return last.id;
  let highest = -1;
  for (const entry of ring) {
    const match = TEXT_COUNTER_ID.exec(entry.id);
    if (match && match[1] === item.key) highest = Math.max(highest, Number(match[2]));
  }
  return `text:${item.key}:${highest + 1}`;
}

export function isCursorStatusContent(content: string): boolean {
  return content.trim().toLowerCase() === "waking up...";
}
